export default __webpack_public_path__ + "static/media/ranes9.69e15924.jpg";